// extracted by mini-css-extract-plugin
module.exports = {"btn":"ReportGenerator_btn__1vSkS","ReportGeneratorBox":"ReportGenerator_ReportGeneratorBox__3nMYR"};